import script from "./Background.vue?vue&type=script&setup=true&lang=ts"
export * from "./Background.vue?vue&type=script&setup=true&lang=ts"

import "./Background.vue?vue&type=style&index=0&id=e0621092&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0621092"]])

export default __exports__